import CartItem from "@/features/cart/components/CartItem/CartItem";

import { FormattedCartItem } from "@/lib/centra/formatters";
import { useCart } from "@/lib/centra/hooks";
import { BaseSelectionItem } from "@frend-digital/centra-types/selection";
import clsx from "clsx";
import { useMemo } from "react";
import { useRemovedProduct } from "../../cartStore";
import { CartItemToast } from "../CartItem/CartItemToast";
import styles from "./cart-items.module.css";

interface ICartItemsProps {
  isFinalized?: boolean;
  items?: FormattedCartItem[];
}

type RemovedProductExtended = {
  removed: true;
} & BaseSelectionItem;

type ItemsWithRemoved = Array<BaseSelectionItem | RemovedProductExtended>;

export const CheckoutCartItems = ({
  items,
}: {
  items: FormattedCartItem[];
}) => {
  return items.map((item, i) => <CartItem item={item} key={i} isFinalized />);
};

const CartItems = ({ isFinalized, items: externalItems }: ICartItemsProps) => {
  const { data: cart } = useCart();
  const cartItems = useMemo(() => cart?.items ?? [], [cart]);
  const items = externalItems ?? cartItems;

  const removedItem = useRemovedProduct(state => state.item);
  const itemsWithRemoved = useMemo<ItemsWithRemoved>(() => {
    if (!removedItem) {
      return items || [];
    }

    const newItems: ItemsWithRemoved = [...(items || [])];

    const removedItemIndex = items?.findIndex(
      item => item.item === removedItem.item,
    );

    const itemAtPosition = items?.[removedItemIndex];
    let deleteCount = 0;
    if (itemAtPosition?.item === removedItem.item) {
      deleteCount = 1;
    }

    newItems.splice(removedItemIndex, deleteCount, {
      ...removedItem,
      removed: true,
    });

    return newItems;
  }, [items, removedItem]);
  return (
    <div className={clsx(styles.container, isFinalized && styles.finalized)}>
      {itemsWithRemoved?.map((item, i) => {
        if ("removed" in item) {
          return <CartItemToast item={item} key={i} />;
        }

        return <CartItem item={item} key={i} isFinalized={isFinalized} />;
      })}
    </div>
  );
};

export default CartItems;
